<template>
  <div id="app"
    :class="this.viewport.label">
    <transition name="loader">
      <global-loader v-show="loading" />
    </transition>
    <router-view />
  </div>
</template>

<script>
import GlobalLoader from '@/components/GlobalLoader'
import { mapGetters } from 'vuex'

export default {
  components: {
    GlobalLoader
  },
  computed: {
    ...mapGetters([
      'loading',
      'viewport'
    ])
  }
}
</script>

<style lang="scss">
@import "./assets/mixins/breakpoints";
@import "./assets/mixins/typo";
@import "./assets/fonts/fonts";

html {
  /*font-size: 62.5%;*/
  text-rendering: optimizeLegibility; -webkit-font-smoothing: antialiased;
}

body {
  margin: 0;
  background-color: #F8F8F8;
  font-family: 'IBM Plex Sans Condensed', sans-serif;
  font-weight: 300;
}

strong, h1, h2, h3, h4, h5{
  font-family: 'IBM Plex Mono', sans-serif;
  font-weight: 700;
}

.loader-enter {
  opacity: 0;
}

.loader-enter-to {
  opacity: 1;
}

.loader-leave {
  opacity: 1;
}

.loader-leave-to {
  opacity: 0;
}

.loader-enter-active, .loader-leave-active {
  transition: opacity .5s;
}

* {
  position: relative;
  box-sizing: border-box;
}

ul, li, ol {
  list-style: none;
  list-style-type: none;
  padding: 0; margin: 0;
}

.default-container {
  width: 100%;
  padding: 0 1.5rem;
  box-sizing: border-box;
  margin: 0 auto;
  @media #{$medium_mq} {
    padding: 0 1.925rem;
  }
  @media #{$large_mq} {
    max-width: 900px;
  }
  @media #{$morelarge_mq} {
    max-width: 1040px;
  }
  @media #{$xlarge_mq} {
    max-width: 1260px;
  }
  @media #{$xxlarge_mq} {
    max-width: 1440px;
  }
}

.less-text-width{
  h1, h2, h3, h4, h5, p, li {
    width: 90%;
    @media #{$large_mq} {
      font-size: 1.2rem;
      width: 80%;
    }
    @media #{$xlarge_mq} {
      width: 70%;
    }
  }
  br {
    display: none;
    @media #{$large_mq} {
      display: block;
    }
  }
}

.default-container.default-container--menu{
  @media #{$large_mq} {
    max-width: 1030px;
  }
  @media #{$morelarge_mq} {
    max-width: 1100px;
  }
  @media #{$xlarge_mq} {
    max-width: 1340px;
  }
  @media #{$xxlarge_mq} {
    max-width: 1520px;
  }
  .menu-wrapper{
    @media #{$large_mq} {
      margin: 0 40px;
    }
  }
}

.default-container-smaller {
  width: 100%;
  padding: 0 1.925rem;
  box-sizing: border-box;
  margin: 0 auto;
  @media #{$large_mq} {
    max-width: 900px;
  }
  @media #{$xlarge_mq} {
    max-width: 1000px;
  }
  @media #{$xxlarge_mq} {
    max-width: 1120px;
  }
}

h1, h2, h3, h4 {
  font-weight: 400;
  font-style: normal;
}

.show-for-medium {
  display: none;
  @media #{$medium_mq} {
    display: block;
  }
}

.hide-for-medium {
  display: block;
  @media #{$medium_mq} {
    display: none;
  }
}

.show-for-large{
  display: none;
  @media #{$large_mq} {
    display: block;
  }
}

.padding-paragrafo-bottom{
  padding-bottom: 40px;
  @media #{$large_mq} {
    padding-bottom: 60px;
  }
  @media #{$xlarge_mq} {
    padding-bottom: 90px;
  }
}

.padding-paragrafo{
  padding: 90px 0;
  &.padding-paragrafo--less-top{
    padding: 0 0 90px;
  }
  &.padding-paragrafo--less-bottom{
    padding: 90px 0 0;
  }
  &.padding-paragrafo--less{
    padding: 100px 0;
  }
  &.padding-paragrafo--less--no-bottom{
    padding-bottom: 30px !important;
  }
  &.padding-paragrafo--less--no-top{
    padding-top: 30px;
  }
  @media #{$medium_mq} {
    padding: 120px 0 140px;
    &.padding-paragrafo--less-top{
      padding: 0 0 140px;
    }
    &.padding-paragrafo--less-bottom{
      padding: 140px 0 0;
    }
    &.padding-paragrafo--less{
      padding: 110px 0;
    }
  }
  @media #{$large_mq} {
    padding: 160px 0 180px;
    &.padding-paragrafo--less-top{
      padding: 30px 0 180px;
    }
    &.padding-paragrafo--less-bottom{
      padding: 180px 0 30px;
    }
    &.padding-paragrafo--less{
      padding: 120px 0;
    }
  }
  @media #{$xlarge_mq} {
    padding: 190px 0 220px;
    &.padding-paragrafo--less-top{
      padding: 35px 0 220px;
    }
    &.padding-paragrafo--less-bottom{
      padding: 220px 0 35px;
    }
    &.padding-paragrafo--less{
      padding: 140px 0;
    }
  }
  @media #{$xxlarge_mq} {
    padding: 220px 0 240px;
    &.padding-paragrafo--less-top{
      padding: 40px 0 240px;
    }
    &.padding-paragrafo--less-bottom{
      padding: 240px 0 40px;
    }
    &.padding-paragrafo--less{
      padding: 160px 0;
    }
  }
  &.--grey{
    background: #EFEFEC 0% 0% no-repeat padding-box;
  }
}

/* Vendors, plugins overrides */

/* @group Cookiebot banners and widgets */
#CookiebotWidget, #CookiebotWidget:not(.CookiebotWidget-inactive) {
  display: none;
  visibility: hidden;
}
#CybotCookiebotDialogPoweredByText {
  display: none !important;
}
#CybotCookiebotDialog {
  // background: #F2F2F2 !important;
  background: #FFF !important;
  color: #343434 !important;
  box-shadow: 3px 3px 10px #00000029 !important;
  border-radius: 10px !important;
  font-family: 'IBM Plex Mono', sans-serif;
  font-weight: 400;
  max-width: 580px !important;
  top: unset !important;
  left: 25px !important;
  bottom: 3% !important;
  transform: none !important;
  @media #{$medium_mq} {
    left: 50px !important;
  }
}
#CybotCookiebotDialog, #CybotCookiebotDialog * {
  font-size: 12px !important;
}
li.CybotCookiebotDialogNavItem:last-child {
  display: none;
}
#CybotCookiebotDialogNav {
  border-bottom: none !important;
}
#CybotCookiebotDialogNav .CybotCookiebotDialogNavItemLink {
  color: #343434 !important;
  border-bottom: 1px solid #343434 !important;
}
#CybotCookiebotDialog div.CookieCard {
  border-bottom: none !important;
}
#CybotCookiebotDialogTabContent .CybotCookiebotDialogBodyLevelButtonSliderWrapper {
  height: 18px !important;
  width: 40px !important;
}
#CybotCookiebotDialogTabContent .CybotCookiebotDialogBodyLevelButtonSlider::before {
  width: 16px !important;
  height: 16px !important;
  bottom: 1px !important;
  left: 1px !important;
  background-color: #343434 !important;
}
#CybotCookiebotDialogTabContent input:checked+.CybotCookiebotDialogBodyLevelButtonSlider::before, #CybotCookiebotDialog[dir="rtl"] #CybotCookiebotDialogTabContent input+.CybotCookiebotDialogBodyLevelButtonSlider::before {
  transform: translateX(22px) !important;
}
@media screen and (max-width: 600px) {
  #CybotCookiebotDialog {
    width: 260px !important;
    max-height: calc(100% - 70px) !important;
  }
  #CookiebotWidget:not(.CookiebotWidget-inactive){
    display: none;
    visibility: hidden;
  }
  #CybotCookiebotDialogTabContent .CybotCookiebotDialogBodyLevelButtonSliderWrapper {
    height: 16px !important;
    width: 36px !important;
  }
  #CybotCookiebotDialogTabContent .CybotCookiebotDialogBodyLevelButtonSlider::before {
    width: 14px !important;
    height: 14px !important;
    bottom: 1px !important;
    left: 1px !important;
  }
  #CybotCookiebotDialogTabContent input:checked+.CybotCookiebotDialogBodyLevelButtonSlider::before, #CybotCookiebotDialog[dir="rtl"] #CybotCookiebotDialogTabContent input+.CybotCookiebotDialogBodyLevelButtonSlider::before {
    transform: translateX(20px) !important;
  }
  #CybotCookiebotDialog div.CookieCard {
    border-bottom: none !important;
    font-size: 11px !important;
    line-height: 16px !important;
  }
  #CybotCookiebotDialogFooter .CybotCookiebotDialogBodyButton {
    padding: .5em !important;
  }
}
#CybotCookiebotDialogHeader {
  display: none !important;
}
#CybotCookiebotDialog .CybotCookiebotScrollContainer {
  border-color: #343434 !important;
}
#CybotCookiebotDialogFooter .CybotCookiebotDialogBodyButton {
  background-color: transparent;
  border: 1px solid #343434 !important;
  border-radius: 0.25em;
  color: #343434 !important;
  display: flex;
  font-weight: 600;
  justify-content: center;
  padding: 1em;
  user-select: none;
  width: 100%;
  font-size: 14px;
}

#CybotCookiebotDialogFooter #CybotCookiebotDialogBodyLevelButtonCustomize, #CybotCookiebotDialogFooter #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection {
  background-color: transparent;
  border-color: #343434 !important;
  color: #343434 !important;
}

#CybotCookiebotDialogFooter #CybotCookiebotDialogBodyButtonAccept, #CybotCookiebotDialogFooter #CybotCookiebotDialogBodyLevelButtonAccept, #CybotCookiebotDialogFooter #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll {
  background-color: #343434 !important;
  border-color: #343434 !important;
  color: #343434 !important;
}
#CybotCookiebotDialogFooter #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll {
  color: #FFF !important;
}

#CybotCookiebotDialogNav .CybotCookiebotDialogNavItemLink.CybotCookiebotDialogActive {
  // border-bottom: 1px solid #343434 !important;
  border-width: 3px !important;
  // color: #343434 !important;
  color: #343434 !important;
}
#CybotCookiebotDialogTabContent .CybotCookiebotDialogBodyLevelButtonSlider {
  background-color: #d1d1d1 !important;
  border-radius: 23px !important;
}
#CybotCookiebotDialog .CybotCookiebotDialogBodyLevelButtonSliderWrapperDisabled span.CybotCookiebotDialogBodyLevelButtonSlider {
  background-color: red !important;
}
#CybotCookiebotDialogTabContent input:checked+.CybotCookiebotDialogBodyLevelButtonSlider {
  background-color: #35a788 !important;
}
#CybotCookiebotDialogNav .CybotCookiebotDialogNavItemLink:hover {
  color: #343434 !important;
}
#CybotCookiebotDialog .CybotCookiebotFader {
  display: none !important;
  // background-image: linear-gradient(to top, rgb(39, 39, 39), rgba(39, 39, 39, 0.8), rgba(39, 39, 39, 0)) !important;
}
#CybotCookiebotDialog .CybotCookiebotScrollContainer>div:first-of-type {
  scrollbar-track-color: #272727 !important;
  scrollbar-face-color: #343434 !important;
  scrollbar-color: #343434 #272727 !important;
  scrollbar-width: thin !important;
}
#CybotCookiebotDialogDetailBodyContentCookieContainerTypes .CybotCookiebotDialogDetailBodyContentCookieProvider:not(.CybotCookiebotDialogDetailBodyContentCookieInfoCount) {
  color: #343434 !important;
}
#CybotCookiebotDialog .CookieCard .CybotCookiebotDialogDetailBodyContentCookieContainerButton:hover, #CybotCookiebotDialog .CookieCard .CybotCookiebotDialogDetailBodyContentIABv2Tab:hover, #CybotCookiebotDialogDetailBodyContentCookieContainerTypes .CybotCookiebotDialogDetailBodyContentCookieProvider:not(.CybotCookiebotDialogDetailBodyContentCookieInfoCount):hover {
  color: #343434 !important;
}
#CybotCookiebotDialogDetailBodyContentCookieContainerTypes .CybotCookiebotDialogDetailBodyContentCookieGroup {
  border-color: #343434 !important;
}
/* stylelint-disable no-descending-specificity */
#CybotCookiebotDialog #CybotCookiebotDialogBodyContentText a, #CybotCookiebotDialog #CybotCookiebotDialogBodyLevelButtonIABHeaderViewPartnersLink, #CybotCookiebotDialog #CybotCookiebotDialogDetailBulkConsentList dt a, #CybotCookiebotDialog #CybotCookiebotDialogDetailFooter a, #CybotCookiebotDialog .CybotCookiebotDialogBodyLevelButtonIABDescription a, #CybotCookiebotDialog .CybotCookiebotDialogDetailBodyContentCookieLink, #CybotCookiebotDialogDetailBodyContentTextAbout a {
  color: #343434 !important;
  text-decoration: underline !important;
}
/* stylelint-enable no-descending-specificity */
#CybotCookiebotDialogTabContent input[type="checkbox"][disabled]:checked+.CybotCookiebotDialogBodyLevelButtonSlider {
  opacity: .3;
}
#CybotCookiebotDialogTabContent .CybotCookiebotDialogDetailBulkConsentCount {
  background-color: #d6d6d6 !important;
  color: #343434 !important;
}
#CybotCookiebotDialogDetailBodyContentCookieContainerTypes .CybotCookiebotDialogDetailBodyEmptyCategoryMessage {
  border-color: #343434 !important;
}
#CybotCookiebotDialogDetailBodyContentCookieContainerTypes .CybotCookiebotDialogDetailBodyContentCookieInfo.CybotCookiebotDialogShow:first-of-type::before {
  border-color: #343434 !important;
}
#CybotCookiebotDialogDetailBodyContentCookieContainerTypes .CybotCookiebotDialogDetailBodyContentCookieInfo {
  border-color: #343434 !important;
}
#CybotCookiebotDialogDetailBodyContentCookieContainerTypes .CybotCookiebotDialogDetailBodyContentCookieInfoFooter {
  border-color: #343434 !important;
}

</style>
